<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="巡检编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入巡检编号" v-model="queryParam.code"></a-input>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker style="width:100%" v-model="queryParam.date" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateChange" @ok="onDateOk" />
                </a-form-item>
              </a-col> -->
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
              
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button @click="myHandleAdd" type="primary" icon="plus">新增</a-button>
          <a-button v-if="btnEnableList.indexOf(1)>-1" icon="delete" @click="batchDel">删除</a-button>
          <a-popover trigger="click" placement="right">
            <template slot="content">
              <a-checkbox-group @change="onColChange" v-model="settingDataIndex" :defaultValue="settingDataIndex">
                <a-row style="width: 500px">
                  <template v-for="(item,index) in defColumns">
                    <template>
                      <a-col :span="8">
                        <a-checkbox :value="item.dataIndex">
                          <j-ellipsis :value="item.title" :length="10"></j-ellipsis>
                        </a-checkbox>
                      </a-col>
                    </template>
                  </template>
                </a-row>
                <a-row style="padding-top: 10px;">
                  <a-col>
                    恢复默认列配置：<a-button @click="handleRestDefault" type="link" size="small">恢复默认</a-button>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </template>
            <a-button icon="setting">列设置</a-button>
          </a-popover>
          <a-tooltip placement="left" title="可以进行库存初始化，生产管理模块的成品入库。" slot="action">
            <a-icon v-if="btnEnableList.indexOf(1)>-1" type="question-circle" style="font-size:20px;float:right;" />
          </a-tooltip>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table 
            ref="table" 
            size="middle" 
            bordered 
            rowKey="id" 
            :columns="columns" 
            :dataSource="dataSource" 
            :components="handleDrag(columns)" 
            :pagination="ipagination"  
            :scroll="{ x: true }"  
            :loading="loading" 
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" 
            @change="handleTableChange"
          >
            <span slot="action" slot-scope="text, record">
              <!-- <a @click="myHandleDetail(record, '其它入库', prefixNo)">查看</a> -->
              <a @click="HandleRoutDetail(record)">查看</a>
              <a-divider type="vertical" />
              <a @click="HandleRoutEdit(record)"
                :disabled="record.state !== 0"
                :style="{ cursor: record.state !== 0 ? 'not-allowed' : 'pointer', opacity: record.state !== 0 ? 0.5 : 1 }"
              >编辑</a>
              <a-divider type="vertical" />
              <!-- <a @click="handleVerify(record)">审核</a> -->
              <a 
                @click="handleVerify(record)"
                :disabled="record.state !== 0"
                :style="{ cursor: record.state !== 0 ? 'not-allowed' : 'pointer', opacity: record.state !== 0 ? 0.5 : 1 }"
              >审核</a>
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => myHandleDelete(record)">
                <a
                :disabled="record.state !== 0"
                :style="{ cursor: record.state !== 0 ? 'not-allowed' : 'pointer', opacity: record.state !== 0 ? 0.5 : 1 }"
                >删除</a>
              </a-popconfirm>
            </span>
            <template slot="customRenderState" slot-scope="state">
              <a-tag v-if="state == '0'" color="red">未审核</a-tag>
              <a-tag v-else-if="state == '1'" color="green">审核中</a-tag>
              <a-tag v-else-if="state == '2'" color="orange">审核通过</a-tag>
              <a-tag v-else-if="state == '3'" color="orange">未通过</a-tag>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <add-rout ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></add-rout>
        <rout-detail ref="routDetail" @ok="routDetailOk" @close="routDetailClose"></rout-detail>
        <bill-detail ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></bill-detail>
        <bill-excel-iframe ref="billExcelIframe" @ok="modalFormOk" @close="modalFormClose"></bill-excel-iframe>
      </a-card>
    </a-col>
  </a-row>
</template>
<!--power by ji shenghua-->
<script>
import addRout from './modules/addRout'
import RoutDetail from './modules/routDetail'
import BillDetail from './dialog/BillDetail'
import BillExcelIframe from '@/components/tools/BillExcelIframe'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { BillListMixin } from './mixins/BillListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import { updateQualityStatus, getSpotDetail } from '@/api/api'
import Vue from 'vue'
export default {
  name: 'OtherInList',
  mixins: [JeecgListMixin, BillListMixin],
  components: {
    addRout,
    BillDetail,
    BillExcelIframe,
    JEllipsis,
    JDate,
    RoutDetail,
  },
  data() {
    return {
      // 查询条件
      queryParam: {
        code: '',
        date: '',
      },
      prefixNo: 'XJJL',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认索引
      defDataIndex: [
        'action',
        'code',
        'preparedBy',
        'date',
        'temperature',
        'humidity',
        'remark',
        'preparedBy',
        'reviewer',
        'state',
      ],
      // 默认列
      defColumns: [
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 160,
          scopedSlots: { customRender: 'action' },
        },
        { title: '巡检编号', dataIndex: 'code', width: 120, ellipsis: true },
        {
          title: '巡检记录人',
          dataIndex: 'preparedBy',
          width: 160,
          ellipsis: true
        },
        { title: '巡检记录时间', dataIndex: 'date', width: 140 },
        // { title: '仓库', dataIndex: 'warehouse', width: 220, ellipsis: true },
        { title: '温度（℃）', dataIndex: 'temperature', width: 145 },
        { title: '湿度（%）', dataIndex: 'humidity', width: 80, ellipsis: true },
        { title: '备注', dataIndex: 'remark', width: 60 },
        { title: '审核人', dataIndex: 'reviewer', width: 200 },
        {
          title: '状态',
          dataIndex: 'state',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'customRenderState' },
        },
      ],
      url: {
        list: '/quality/spotInspection/list',
        delete: '/quality/spotInspection/delete',
        deleteBatch: '/depotHead/deleteBatch',
        batchSetStatusUrl: '/depotHead/batchSetStatus',
      },
    }
  },
  computed: {},
  created() {
    this.initSystemConfig()
    this.initSupplier()
    this.getDepotData()
    this.initUser()
  },
  methods: {
    // 查看详情
    async HandleRoutDetail(record){
      const res = await getSpotDetail({id:record.id})
      if( res.code == 200 && res.success == true ){
        this.$refs.routDetail.show(res.result)
      } else {
        this.$message.warning(res.message)
      }

    },
    // 审核
    async handleVerify(record){
      const params = {
        id: record.id,
      }
      const res = await updateQualityStatus(params)
      if( res.code == 200 && res.success == true ){
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.warning(res.message)
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>